import {
  PRODUCTS_ROUTE,
  EXPIRED_PRODUCTS_ROUTE,
  USERS_ROUTE,
  SETTINGS_ROUTE,
  ADMIN_STORES_ROUTE,
  ADMIN_USERS_ROUTE,
  ADMIN_IMPORT_ROUTE,
  ADMIN_EXPIRY_DATE_CONTROL_ROUTE,
  ADMIN_SETTINGS_ROUTE,
  SUPER_ADMIN_CLIENTS_ROUTE,
  SUPER_ADMIN_USERS_ROUTE,
  PRIVACY_POLICY_URL
} from "../../utils/Constants";

import ExpiredProductsIcon from "../../assets/expired_products.svg";
import ProductsStoresIcon from "../../assets/produtos_stores.svg";
import UsersIcon from "../../assets/users.svg";
import SettingsIcon from "../../assets/settings.svg";
import ImportSheetIcon from "../../assets/import_sheet.svg";
import PrivacyPolicyIcon from "../../assets/privacy_policy.svg";

export const sidebarItems = [
  {
    key: "products",
    icon: ProductsStoresIcon,
    label: {
      superadmin: "Clientes",
      admin: "Lojas",
      store: "Produtos"
    },
    route: {
      superadmin: SUPER_ADMIN_CLIENTS_ROUTE,
      admin: ADMIN_STORES_ROUTE,
      store: PRODUCTS_ROUTE
    }
  },
  {
    key: "users",
    icon: UsersIcon,
    label: "Usuários",
    route: {
      superadmin: SUPER_ADMIN_USERS_ROUTE,
      admin: ADMIN_USERS_ROUTE,
      store: USERS_ROUTE
    }
  },
  {
    key: "expired",
    icon: ExpiredProductsIcon,
    label: {
      admin: ["Controle", "Validade"],
      store: ["Produtos", "Vencidos"]
    },
    route: {
      admin: ADMIN_EXPIRY_DATE_CONTROL_ROUTE,
      store: EXPIRED_PRODUCTS_ROUTE
    },
    hideForSuperAdmin: true
  },
  {
    key: "import",
    icon: ImportSheetIcon,
    label: "Importação",
    route: {
      admin: ADMIN_IMPORT_ROUTE
    },
    adminOnly: true,
    hideForSuperAdmin: true
  },
  {
    key: "privacy",
    icon: PrivacyPolicyIcon,
    label: ["Política de", "Privacidade"],
    externalUrl: PRIVACY_POLICY_URL,
    bottom: true
  },
  {
    key: "settings",
    icon: SettingsIcon,
    label: "Configurações",
    route: {
      admin: ADMIN_SETTINGS_ROUTE,
      store: SETTINGS_ROUTE
    },
    bottom: true,
    hideForSuperAdmin: true
  }
];